import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const AlertDialog = () => {
  const [display, setDisplay] = React.useState(false);
  
  const [title, setTitle] = React.useState('');
  const [msg, setMsg] = React.useState('');
  
  const [confirmTitle, setConfirmTitle] = React.useState('');
  const [closeTitle, setCloseTitle] = React.useState('');

  AlertDialog.setDisplay = setDisplay;
  AlertDialog.setTitle = setTitle;
  AlertDialog.setMsg = setMsg;
  AlertDialog.setConfirmTitle = setConfirmTitle;
  AlertDialog.setCloseTitle = setCloseTitle;

  const onClose = () => {
    setDisplay(false);
    if (AlertDialog.onClose) {
      AlertDialog.onClose();
    }
  }

  const onConfirm = async () => {
    if (AlertDialog.onConfirm) {
      if (await AlertDialog.onConfirm()) {
        setDisplay(false);
      }
    } else {
      setDisplay(false);
    }
  }
  
  return (
    <Dialog
      open={display}
      onClose={AlertDialog.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            minWidth: "300px",
          },
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {msg}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{closeTitle}</Button>
        <Button onClick={onConfirm} autoFocus>{confirmTitle}</Button>
      </DialogActions>
    </Dialog>
  );
}

// AlertDialog.onClose = (event, reason) => {
//   if (reason === 'clickaway') {
//     return;
//   }
//   AlertDialog.setDisplay(false);
// }

AlertDialog.showAlert = (param) => {

  AlertDialog.setDisplay(true);
  AlertDialog.setTitle(param.title);
  AlertDialog.setMsg(param.msg);
  AlertDialog.setConfirmTitle(param.confirmTitle);
  AlertDialog.setCloseTitle(param.closeTitle);


  AlertDialog.onConfirm = param.onConfirm;
  AlertDialog.onClose = param.onClose;
}

export default AlertDialog;